import type { ClaimWithRelations } from "../../api/use-claim";

type FamilyWithEmails = Pick<
  ClaimWithRelations["usersClaimsFamilies"][number],
  "id" | "familyName" | "email"
> & {
  familyClaimAcquisition: Array<{ toEmail: string }>;
};

function normalize(email: string | null | undefined): string {
  return email?.trim().toLowerCase() ?? "";
}

/**
 * The other family of the claim that already receives mail at this address, if any.
 *
 * A couple or a family sharing one mailbox is legitimate (TECH-1202), so this never blocks: it lets
 * the jurist confirm before a second signature request lands in the same inbox. The family's
 * `email` and its acquisition's `toEmail` can drift apart after a correction, so both are read.
 */
export function findFamilyUsingEmail(
  families: FamilyWithEmails[],
  email: string,
  familyId: string,
): FamilyWithEmails | undefined {
  const address = normalize(email);
  if (!address) {
    return undefined;
  }

  return families.find(
    (family) =>
      family.id !== familyId &&
      (normalize(family.email) === address ||
        family.familyClaimAcquisition.some(({ toEmail }) => normalize(toEmail) === address)),
  );
}

export function sharedEmailWarning(familyName: string): string {
  return `Cette adresse mail est déjà utilisée pour la famille ${familyName}, êtes-vous sûr de vouloir poursuivre ?`;
}
